import service, { get, post } from '@/utils/request';
import { getUserInfo } from '@/utils/auth';

const userInfo = (getUserInfo() != null ? JSON.parse(String(getUserInfo())) : {});


// 基础路径
const baseURL = service.defaults.baseURL;

/**
 * 接口地址
 */
export const sliderApi = {
    /**
     * 轮播图
     */
    all: `${baseURL}/api/visitor/slider/all`
};


/**
 * 接口服务
 */
const sliderService = {
    /**
     * 轮播图
     */
    all: async () => {
        const res = await get(sliderApi.all);
        return res as { code: number; state: string; message?: string; data: any };
    },
};

export default sliderService;